module.exports = __webpack_public_path__ + "img/icon-place.4ed85ffb.svg";